var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools02-parameter"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v("パラメータ引継ぎ設定")])])],1),_c('Tools02ParameterManualManualSystem',{attrs:{"category01":_vm.category01,"category02":_vm.category02,"unitId":_vm.unitId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }